module.exports = __webpack_public_path__ + "static/media/VidgoLogo.9dfe1457.svg";